import React from 'react';
import { Alert, Button } from 'ALIASED-antd';
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';

type BlockedMediaPermissionsWarning = {
  style?: React.CSSProperties;
  handleDismiss: () => void;
  handleRefreshPage: () => void;
};

const BlockedMediaPermissionsWarning = ({
  style,
  handleDismiss,
  handleRefreshPage
}: BlockedMediaPermissionsWarning) => {
  const { t } = useTranslation('common');

  return (
    <Alert
      css={css({ marginBottom: '1rem', ...style })}
      message={t('MediaPermissionsBlocked')}
      type="error"
      showIcon
      closable
      afterClose={handleDismiss}
      description={
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <span>{t('MediaPermissionsBlockedDescription')}</span>
          <Button
            type="primary"
            onClick={handleRefreshPage}
            data-testid="refresh-page-button"
            style={{ width: 'fit-content' }}
          >
            {t('RefreshPage')}
          </Button>
        </div>
      }
    />
  );
};

export default BlockedMediaPermissionsWarning;
